export { TenderContractDashboardSupplierComponent } from './tender-contract-dashboard-supplier.component';
